import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useDisplayMode } from '../../hooks/useDisplayMode';
import InstallPrompt from './InstallPrompt';
import PwaUpdatePrompt from './PwaUpdatePrompt';

const AUTH_ROUTES = new Set(['/login', '/forgot-password', '/reset-password', '/privacy']);

const PwaOverlays: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  useDisplayMode();

  if (!isAuthenticated || AUTH_ROUTES.has(pathname)) {
    return null;
  }

  return (
    <>
      <PwaUpdatePrompt />
      <InstallPrompt />
    </>
  );
};

export default PwaOverlays;
